import axios from 'axios';
import { setupAuthInterceptors } from './authInterceptors';

const api = axios.create({
  baseURL: process.env.REACT_APP_FIGHT_AUTH_API,
});

setupAuthInterceptors(api);

export default api;
